import React from "react";
import "./style.scss";

const List = ({ children, className = "", style }) => {
  return (
    <div className={`listComp ${className}`} style={style}>
      {children}
    </div>
  );
};

export { List };
